import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';

import {
  Box,
  MenuItem,
  Typography,
} from '@mui/material';
import { Apartment } from '@mui/icons-material';
import styles from './styles';

import { useWorkspaceContext } from '../../../../contexts/workspace';

const ChangeActionRaw = ({
  className,
  activeClient,
  clients,
}) => {
  const {
    workspace: { handleChangeWsAndClient },
  } = useWorkspaceContext();

  return (
    <Box className={className}>
      {
        clients.filter((el) => el.id !== activeClient).map(({
          id,
          company,
        }) => (
          <MenuItem
            key={id}
            onClick={() => handleChangeWsAndClient({ clientId: id })}
          >
            <Typography className="dn-flex-middle">
              <Apartment />
              <Box as="span">{company}</Box>
            </Typography>
          </MenuItem>
        ))
      }
    </Box>
  );
};

ChangeActionRaw.propTypes = {
  className: PropTypes.string,
  clients: PropTypes.array,
  activeClient: PropTypes.string,
};

const ChangeAction = styled(ChangeActionRaw)(styles);

ChangeAction.propTypes = ChangeActionRaw.propTypes;

export default ChangeAction;
